"use client";

import React from "react";
import { Car, House, Heart, Briefcase, ArrowRight, Sparkle } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardHeader, CardTitle, CardContent, CardFooter, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const coverageOptions = [{
  title: "Birth Support",
  description: "Continuous physical, emotional, and informational support during labor to help you achieve a safe and empowering birth experience in West Palm Beach.",
  icon: Heart,
  link: "/SpecializedCarePage"
}, {
  title: "Postpartum Care",
  description: "Dedicated support during the early weeks at home, focusing on maternal recovery, newborn care, and household harmony during your transition.",
  icon: House,
  link: "/SpecializedCarePage"
}, {
  title: "Lactation Counseling",
  description: "Expert guidance for your breastfeeding journey, offering clinical support and compassionate troubleshooting for you and your baby's unique needs.",
  icon: Briefcase,
  link: "/SpecializedCarePage"
}, {
  title: "Specialized Support",
  description: "Holistic care tailored for VBAC/HBAC journeys, overnight newborn support, and travel doula services for families seeking premium care.",
  icon: Car,
  link: "/SpecializedCarePage"
}];
function Divider() {
  return <div className="mt-16 flex items-center justify-center w-full">
      <div className="bg-[#D9C5A3] h-[1px] flex-grow" />
      <Sparkle className="text-[#D9C5A3] mx-4 h-5 w-5" />
      <div className="bg-[#D9C5A3] h-[1px] flex-grow" />
    </div>;
}
export default function GuidedCareTiers() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223160" id="guided-care-tiers" className="py-20 lg:py-28 text-background bg-primary">
      <div className="container mx-auto px-4 md:px-6">
        <div className="mb-12 text-center md:mb-16">
          <h2 className="mb-4 text-3xl tracking-tight !font-normal text-secondary !font-serif md:text-4xl lg:text-5xl">
            Guided Care Tiers
          </h2>
          <p className="mx-auto max-w-2xl text-lg font-sans text-primary-foreground">
            Expertly held support through every stage of your journey into parenthood. We provide the professional care you need to feel confidence and nurtured.
          </p>
        </div>

        <div ref={ref} className={`grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          {coverageOptions.map((option, i) => <div data-index={i} key={i} className="h-full">
              <Card className="group bg-card hover:-translate-y-2 hover:shadow-md transition-all duration-300 h-full flex flex-col border border-border/40 shadow-sm rounded-lg">
                <CardHeader className="@container/card-header @container/card-header grid auto-rows-min grid-rows-[auto_auto] items-start gap-1.5 px-6 has-data-[slot=card-action]:grid-cols-[1fr_auto] [.border-b]:pb-6 pb-4 text-primary">
                  <div className="bg-secondary/50 text-primary mb-4 flex h-14 w-14 items-center justify-center rounded-xl transition-colors group-hover:bg-chart-1/20 group-hover:text-chart-1">
                    <option.icon className="h-7 w-7" />
                  </div>
                  <CardTitle className="font-semibold font-default text-xl text-secondary">
                    {option.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="flex-grow pb-2">
                  <CardDescription className="text-base leading-relaxed font-sans text-primary-foreground">
                    {option.description}
                  </CardDescription>
                </CardContent>
                <CardFooter className="pt-4 mt-auto">
                  <Link to={option.link} className="text-primary group/link inline-flex items-center font-medium transition-colors hover:text-chart-1">
                    Learn More
                    <ArrowRight className="ml-2 h-4 w-4 transition-transform group-hover/link:translate-x-1" />
                  </Link>
                </CardFooter>
              </Card>
            </div>)}
        </div>

        <Divider />
      </div>
    </section>;
}